<template>
  <v-footer class="pw-login-footer" padless>
    <div class="pw-login-footer__inner">
      Copyright © {{ new Date().getFullYear() }} WRKTOP Technologies. All rights
      reserved.
    </div>
  </v-footer>
</template>
